import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query ActivityNotification($event: String, $channel: String) {
  activityNotification(event: $event, channel: $channel) {
    text
  }
}`;

function getActivityNotification(data) {
  return apollo.client.query({
    query,
    variables: {
      event: data.event,
      channel: data.channelIdentifier,
    },
    fetchPolicy: 'network-only',
  }).then((res) => res.data.activityNotification);
}

export default getActivityNotification;
